type Props = {
    url: string,
    label: string,
    icon: string,
}

export function ExternalSidebarMenuItem({ url, label, icon }: Props) {
    return <li className={`menu-item`}>
        <a target="_blank" href={url} className="menu-link">
            <i className={`menu-icon tf-icons bx bx-${icon}`}></i>
            <div>{label}</div>
        </a>
    </li>
}